interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function PageWrapper({ children, className = '' }: PageWrapperProps) {
  return (
    <main className={`flex-1 overflow-y-auto bg-background-light dark:bg-background-dark p-8 ${className}`}>
      {children}
    </main>
  );
}
